import { render } from "./ChargebeeUpsellSettingsSummary.vue?vue&type=template&id=ce5c4a1a&scoped=true"
import script from "./ChargebeeUpsellSettingsSummary.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellSettingsSummary.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellSettingsSummary.vue?vue&type=style&index=0&id=ce5c4a1a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce5c4a1a"]])

export default __exports__